<template lang="pug">
  //- bDropSelector(
  //-   :options="options"
  //-   :value="value"
  //-   @change="$emit('change', $event)"
  //- )
  b-radio-btn(
    :options="options"
    :value="value"
    @change="$emit('change', $event)"
  )
</template>

<script>
export default {
  name: "AlignEditor",
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    options: {
      type: Array,
      default() {
        return [
          {
            label: "",
            value: "off",
            icon: "off"
          },
          {
            label: "",
            value: "start",
            icon: "alignself/start"
          },
          {
            label: "",
            value: "center",
            icon: "alignself/center"
          },
          {
            label: "",
            value: "end",
            icon: "alignself/end"
          },
          {
            label: "",
            value: "stretch",
            icon: "alignself/stretch"
          }
        ];
      }
    },
    value: {
      type: String,
      default: "stretch"
    }
  }
};
</script>
